import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useService } from '../../../services/services';
import Title from '../../../components/common/title';
import Table from '../../../components/common/table/table';
import useDefaultTableTopbar from '../../../components/common/table/default-topbar';
import css from './index.module.css';
import { FARM_USERS_CREATE, FARM_USERS_VIEW } from '../../../router/routes';
import { useParams } from 'react-router';
import { FarmUser } from '../../../interfaces/farm-user';
import { route } from '../../../services/utils';
import { ActiveFilter } from '../../../components/common/table/active-filter';

export default function FarmUsers() {
  const { t } = useTranslation();
  const { farmId } = useParams<{ farmId: string }>();
  const { farmUserService } = useService();
  const [TopbarComponent] = useDefaultTableTopbar(
    route(FARM_USERS_CREATE, { farmId })
  );

  const request = useCallback(
    (page: number, sort: string, desc: boolean, filter: any) =>
      farmUserService.index(farmId, { page, sort, desc, ...filter }),
    [farmUserService, farmId]
  );

  return (
    <>
      <Title title={t('pages.farm.users.title')} />
      <div className={css['body']}>
        {TopbarComponent}

        <Table<FarmUser>
          request={request}
          keyAccessor="id"
          columns={[
            {
              accessor: 'name',
              header: t('pages.farm.users.name'),
              sortable: true,
            },
            {
              accessor: 'email',
              header: t('pages.farm.users.email'),
              sortable: true,
            },
            { accessor: 'main_user', header: t('pages.farm.users.main_user') },
            {
              accessor: 'blocked',
              header: t('pages.farm.users.blocked'),
              filter: (
                <ActiveFilter name={'blocked'} defaultSelectedFilter={'no'} />
              ),
            },
          ]}
          viewRoute={route(FARM_USERS_VIEW, { farmId })}
          viewRecordAbility={{ title: 'Manage farm users' }}
        />
      </div>
    </>
  );
}
